import React from "react";

const getYouTubeId = (url) => {
  const regExp =
    /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/i;
  const match = url?.match(regExp);
  return match ? match[1] : null;
};

const getYouTubeThumbnail = (url) => {
  const id = getYouTubeId(url);
  return id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : null;
};

const ImageView = ({ item }) => {
  if (!item?.url) {
    return <div className="no-image-placeholder">No Image</div>;
  }

  // MP4 video
  if (item.type === "video") {
    return (
      <video className="sample-video" muted preload="metadata">
        <source src={`${item.url}#t=0.1`} type="video/mp4" />
      </video>
    );
  }

  // YouTube video
  if (item.type === "youtube") {
    const thumb = getYouTubeThumbnail(item.url);
    return thumb ? (
      <img src={thumb} alt="YouTube Thumbnail" className="sample-img" />
    ) : (
      <div className="no-image-placeholder">Invalid YouTube URL</div>
    );
  }

  // Normal image
  return <img src={item.url} alt="" className="sample-img" />;
};

export default ImageView;
